module.exports = __webpack_public_path__ + "img/logo_bold_style.f6524767.jpg";